import { defaultStatus } from '../defaultState/defaultState';
import {
  ADD_SPECIALIST_FAILURE,
  ADD_SPECIALIST_REQUEST,
  ADD_SPECIALIST_SUCCESS,
  DELETE_SPECIALIST_FAILURE,
  DELETE_SPECIALIST_REQUEST,
  DELETE_SPECIALIST_SUCCESS,
  FETCH_LIST_SPECIALIST_FAILURE,
  FETCH_LIST_SPECIALIST_REQUEST,
  FETCH_LIST_SPECIALIST_SUCCESS,
  FETCH_SPECIALIST_FAILURE,
  FETCH_SPECIALIST_REQUEST,
  FETCH_SPECIALIST_SUCCESS,
  RESET_CURRENT_SPECIALIST,
  UPDATE_SPECIALIST_FAILURE,
  UPDATE_SPECIALIST_REQUEST,
  UPDATE_SPECIALIST_SUCCESS,
} from './specialistType';

const initialState = {
  specialists: [],
  currentSpecialist: null,
  fetchSpecialists: { ...defaultStatus },
  fetchSpecialist: { ...defaultStatus },
  addSpecialist: { ...defaultStatus },
  updateSpecialist: { ...defaultStatus },
  deleteSpecialist: { ...defaultStatus },
  formMode: null, // 'add' or 'edit'
};

const specialistReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case FETCH_LIST_SPECIALIST_REQUEST:
      return {
        ...state,
        fetchSpecialists: { ...state.fetchSpecialists, inProgress: true },
      };
    case FETCH_LIST_SPECIALIST_SUCCESS:
      return {
        ...state,
        fetchSpecialists: {
          ...state.fetchSpecialists,
          success: true,
          inProgress: false,
          specialists: payload?.specialists?.data,
        },
      };
    case FETCH_LIST_SPECIALIST_FAILURE:
      return {
        ...state,
        fetchSpecialists: {
          ...state.fetchSpecialists,
          error: true,
          errorMessage: payload.error,
        },
      };

    // View single Specialist
    case FETCH_SPECIALIST_REQUEST:
      return {
        ...state,
        fetchSpecialist: { ...state.fetchSpecialist, inProgress: true },
      };
    case FETCH_SPECIALIST_SUCCESS:
      return {
        ...state,
        fetchSpecialist: {
          ...state.fetchSpecialist,
          success: true,
          inProgress: false,
        },
        currentSpecialist: payload.specialist,
      };
    case FETCH_SPECIALIST_FAILURE:
      return {
        ...state,
        fetchSpecialist: {
          ...state.fetchSpecialist,
          error: true,
          errorMessage: payload.error,
        },
      };

    // Add Specialist
    case ADD_SPECIALIST_REQUEST:
      return {
        ...state,
        addSpecialist: { ...state.addSpecialist, inProgress: true },
      };
    case ADD_SPECIALIST_SUCCESS:
      return {
        ...state,
        addSpecialist: {
          ...state.addSpecialist,
          success: true,
          inProgress: false,
        },
        specialists: [...state.specialists, payload.specialist],
        currentSpecialist: payload.specialist,
      };
    case ADD_SPECIALIST_FAILURE:
      return {
        ...state,
        addSpecialist: {
          ...state.addSpecialist,
          error: true,
          errorMessage: payload.error,
        },
      };

    // Edit Specialist
    case UPDATE_SPECIALIST_REQUEST:
      return {
        ...state,
        updateSpecialist: { ...state.updateSpecialist, inProgress: true },
      };
    case UPDATE_SPECIALIST_SUCCESS: {
      const updatedSpecialist = payload.specialist;
      return {
        ...state,
        updateSpecialist: {
          ...state.updateSpecialist,
          success: true,
          inProgress: false,
        },
        specialists: state.specialists.map((specialist) =>
          specialist.id === updatedSpecialist.id
            ? updatedSpecialist
            : specialist
        ),
        currentSpecialist: updatedSpecialist,
      };
    }
    case UPDATE_SPECIALIST_FAILURE:
      return {
        ...state,
        updateSpecialist: {
          ...state.updateSpecialist,
          error: true,
          errorMessage: payload.error,
        },
      };

    // Delete Specialist
    case DELETE_SPECIALIST_REQUEST:
      return {
        ...state,
        deleteSpecialist: { ...state.deleteSpecialist, inProgress: true },
      };
    case DELETE_SPECIALIST_SUCCESS:
      return {
        ...state,
        deleteSpecialist: {
          ...state.deleteSpecialist,
          success: true,
          inProgress: false,
        },
        specialists: state.specialists.filter(
          (specialist) => specialist.id !== payload.specialistId
        ),
        currentSpecialist:
          state.currentSpecialist?.id === payload.specialistId
            ? null
            : state.currentSpecialist,
      };
    case DELETE_SPECIALIST_FAILURE:
      return {
        ...state,
        deleteSpecialist: {
          ...state.deleteSpecialist,
          error: true,
          errorMessage: payload.error,
        },
      };

    // Reset current Specialist
    case RESET_CURRENT_SPECIALIST:
      return {
        ...state,
        currentSpecialist: null,
      };

    default:
      return state;
  }
};

export default specialistReducer;
